import { ReactElement, ReactNode } from 'react'
import { Box, IconButton, Menu, MenuProps } from '.'
import Tooltip from './Tooltip'

export interface Props {
  tooltipContent: ReactNode
  icon: ReactElement
  menuProps: MenuProps<string, boolean>
}

export default function IconMenu({ tooltipContent, icon, menuProps }: Props) {
  return (
    <Tooltip content={tooltipContent}>
      <Box as="span" display="inline-block">
        <Menu {...menuProps} as={IconButton} leftIcon={icon} buttonLabel={false} />
      </Box>
    </Tooltip>
  )
}
